// Arabisch (ar), timePicker: zelfde vorm als timePicker.nl.ts. Tijden blijven in Latijnse cijfers
// (15:30); "د" is de gewone afkorting van دقيقة.
export const appTimePickerAr = {
    open: '{label}: اختيار الوقت',
    hourStep: 'اختر الساعة',
    minuteStep: 'اختر الدقائق',
    hours: 'الساعات',
    minutes: 'الدقائق',
    showNight: 'الليل 00–05',
    back: 'ساعة أخرى',
    close: 'إغلاق',
    type: 'اكتب بنفسك',
    invalid: 'هذا ليس وقتًا. اكتب مثلًا 15:30 أو 930.',
    beforeStart: 'اختر وقتًا بعد {start}.',
    endClamped: 'قُصّر وقت الانتهاء إلى 23:59.',
    durations: 'كم يستغرق؟',
    orPickEnd: 'أو اختر وقت الانتهاء',
    durationUntil: '{duration}، حتى {time}',
    minutesShort: '{count} د',
    hoursShort: {
        zero: '{count} ساعة',
        one: '{count} ساعة',
        two: '{count} ساعة',
        few: '{count} ساعات',
        many: '{count} ساعة',
        other: '{count} ساعة',
    },
};
//# sourceMappingURL=timePicker.ar.js.map